// This filter shows 1 rounded decimal place when passed a float that only has
// one place. It shows 2 rounded decimal places when passed a float that continues
// into the 100ths place. This is just for aesthetic purposes.
angular.module('leanlaw').filter("hoursDecimal", function () {
  return function (input, showZero) {
    if (!input && showZero === false) return '';
    var val = parseFloat(input);

    // Skip bad input
    if (isNaN(val)) {
      // // Throw error only on defined input
      // if (typeof input != "undefined")
      //     throw new Error("Tried to pass non-number to hoursDecimal filter");
      return input;
    }

    // Determine if the value has a hundredths place
    var hasHundredths = Math.round(val * 100) % 10 != 0;
    if (hasHundredths) return val.toFixed(2);
    return val.toFixed(1);
  };
});